//For password encryption in API it is accepting only 16 bytes
//The Key should be 16 bytes only
export const PASSWORD_ENCRYPT_KEY = '9kkj-dkj18c-e96f';
export const ENCRYPT_KEY = '9kkj-dkj18c-e96f5a9ac85a';
//Used in login
export const APPCODE =window?.location?.hostname.substring(0,19); //Used in login
export const INACTIVE_USER_TIME_THRESHOLD = 1200000; //Threshold for session timeout 20 mins
export const USER_ACTIVITY_THROTTLER_TIME = 1000; //To reset check for inactivity 1 sec
export const SYSTEM_ERROR =
  'Unable to perform this transaction, please try later.'; //Api error static message
